import { gql } from '@apollo/client';

import type { Items } from '../../types/Items';
import { type ImageDataProps, fragments as imageFragments } from '../Image';
import type { GalleryTileProps } from '../Tile/query';
import { fragments } from '../Tile/query';

// =================================================================================================
// Related Content Tiles Query
// =================================================================================================

export const tileCollectionAndRelatedContentQuery = gql`
  query TileAndRelatedContentQuery(
    $preview: Boolean!
    $locale: String!
    $ids: [String]!
    $relatedContentId: String!
    $slugId: String
  ) {
    tileCollection(
      preview: $preview
      locale: $locale
      where: { sys: { id_in: $ids }, slugReference: { sys: { id_not: $slugId } } }
    ) {
      total
      items {
        ...TileAll
      }
    }
    relatedContent(preview: $preview, locale: $locale, id: $relatedContentId) {
      defaultImage {
        ...ImageAll
      }
    }
  }
  ${fragments.all}
  ${imageFragments.all}
`;

export type TileQueryResponse = {
  tileCollection: Items<GalleryTileProps>;
  relatedContent?: {
    defaultImage?: ImageDataProps;
  };
};
